export default __webpack_public_path__ + "static/media/DefaultImg.f59ec135.svg";